import React, { useEffect, useState, useCallback } from "react";
import { Row, Col } from "antd";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import {
  Grid,
  BreadCrumbBox,
  ProgrssBox,
  FilterWraper,
  Tabs,
  Typography,
  TabPane,
  Loading,
} from "../../core";
import Svg from "../../assets/icons/icon";
import TransactionDetail from "../../components/TransactionDetail";
import InvoiceDetail from "../../components/InvoiceDetail";
import { getCompanyPayments } from "../../helper/utils/api/payment";
import { getInvoiceWithCompanyId } from "../../helper/utils/api/invoice";
import { mapInvoicesForList } from "../../helper/utils/invoiceMap";
import { getCompanyId } from "../../helper/utils/companyId";
import { getSpecificBuyer } from "../../helper/utils/api/buyer";

const BuyerInfo = styled.div`
  table {
    width: 100%;
  }
  td:first-child {
    padding: 0px 10px;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
  }
  td {
    font-size: 14px;
    line-height: 21px;
    letter-spacing: 0.2px;
    color: #000000;
  }
  tr {
    height: 63.5px;
  }
  tr:nth-child(odd) {
    background: white;
  }
`;

const Transaction = () => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [buyer, setBuyer] = useState(null);
  const [payments, setPayments] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [stats, setStats] = useState({
    paid: 0,
    openInvoice: 0,
    totalInvoices: 0,
  });

  const loadData = useCallback(async () => {
    const companyId = getCompanyId();
    if (!companyId) return;
    setIsLoading(true);
    try {
      const buyerId = location.state?.buyerId || location.state?._id;
      if (buyerId) {
        const buyerRes = await getSpecificBuyer(buyerId);
        setBuyer(buyerRes.data?.result?.[0] || buyerRes.data?.result || null);
      }

      const [paymentsRes, invoicesRes] = await Promise.all([
        getCompanyPayments(companyId),
        getInvoiceWithCompanyId({ companyId, limit: 500 }),
      ]);

      const paymentRows = Array.isArray(paymentsRes.data)
        ? paymentsRes.data
        : paymentsRes.data?.result || [];
      const invoiceRows = mapInvoicesForList(
        invoicesRes.data?.result || invoicesRes.data || []
      );

      setPayments(paymentRows);
      setInvoices(invoiceRows);

      const paidTotal = paymentRows
        .filter((p) => p.payment_option === "paid")
        .reduce((sum, p) => sum + Number(p.payment_amount || 0), 0);
      const openTotal = invoiceRows.reduce(
        (sum, inv) => sum + Number(inv.total_value_include_sale_tax || 0),
        0
      );

      setStats({
        paid: paidTotal,
        openInvoice: openTotal,
        totalInvoices: invoiceRows.length,
      });
    } catch (error) {
      console.log("transaction load error", error);
    }
    setIsLoading(false);
  }, [location.state]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const buyerData = buyer
    ? {
        name: buyer.buyerName || buyer.companyName,
        email: buyer.email || "-",
        phone: buyer.phoneNumber || "-",
        NTN: buyer.NTN || "-",
        STRN: buyer.STRN || "-",
        invoice: { totalInvoice: stats.totalInvoices },
      }
    : {
        name: "Company Transactions",
        email: "-",
        phone: "-",
        NTN: "-",
        STRN: "-",
        invoice: { totalInvoice: stats.totalInvoices },
      };

  return (
    <Grid>
      {isLoading ? <Loading /> : null}
      <BreadCrumbBox tittle="Transaction" />
      <Row type="flex" justify="space-around" gutter={[16, 16]}>
        <ProgrssBox
          svg={<Svg width={59} height={39} icon="money" />}
          status="success"
          tittle="Paid"
          value={String(stats.paid)}
        />
        <ProgrssBox
          svg={<Svg icon="StylishArrow" width={38.81} height={38.81} />}
          status="warnning"
          tittle="Open Invoice"
          value={String(stats.openInvoice)}
        />
        <ProgrssBox
          svg={<Svg icon="warning" width={44} height={38} />}
          status="danger"
          tittle="Order Invoices"
          value={String(stats.totalInvoices)}
        />
      </Row>
      <Row type="flex" gutter={[16, 16]} justify="center">
        <Col lg={6} md={12} xs={24}>
          <BuyerBioData BuyerData={buyerData} />
        </Col>
        <Col lg={18} md={24}>
          <FilterWraper dropDown={false} bg="white" radius="10px 10px 0px 0px">
            <Tabs>
              <TabPane tab="Transactions" key="1">
                <TransactionDetail data={payments} />
              </TabPane>
              <TabPane tab="Invoices" key="2">
                <InvoiceDetail data={invoices} onRefresh={loadData} />
              </TabPane>
            </Tabs>
          </FilterWraper>
        </Col>
      </Row>
    </Grid>
  );
};

const BuyerBioData = ({ BuyerData }) => {
  return (
    <BuyerInfo>
      <Typography
        as="h3"
        weight="bold"
        align="center"
        text={BuyerData.name}
        color="#233B67"
      />
      <table>
        <tbody>
          <tr>
            <td>Invoice</td>
            <td>{BuyerData.invoice.totalInvoice}</td>
          </tr>
          <tr>
            <td>Email</td>
            <td>{BuyerData.email}</td>
          </tr>
          <tr>
            <td>Phone #</td>
            <td>{BuyerData.phone}</td>
          </tr>
          <tr>
            <td>NTN #</td>
            <td>{BuyerData.NTN}</td>
          </tr>
        </tbody>
      </table>
    </BuyerInfo>
  );
};

export default Transaction;
